// src/pages/entradas/VistaEntrada.jsx
import React, { useMemo } from 'react';
import EntradaRender, { normalizarLayoutEntrada } from '../shared/EntradaRender';

function normalizarArteEntrada({ arteEntrada, evento }) {
  const base =
    arteEntrada ||
    evento?.arteEntrada;

  if (!base) return '';
  if (base.startsWith('http://') || base.startsWith('https://')) return base;
  if (base.startsWith('/')) return base;
  if (base.startsWith('eventos/')) return `/${base}`;
  return `/eventos/${base}`;
}

function VistaEntrada({
  id,
  evento,
  arteEntrada,
  layoutEntrada,
  width = 300,
}) {
  const layout = useMemo(() => {
    return normalizarLayoutEntrada(
      layoutEntrada || evento?.layoutEntrada
    );
  }, [layoutEntrada, evento]);

  const fondo = useMemo(
    () => normalizarArteEntrada({ arteEntrada, evento }),
    [arteEntrada, evento]
  );

  if (!fondo) return null;

  return (
    <EntradaRender
      fondo={fondo}
      id={id}
      layout={layout}
      width={width}
    />
  );
}

export default React.memo(VistaEntrada);
